import { NavLink } from "react-router";

import { AuthMenu } from "@/components/auth-menu";
import { ThemeToggle } from "@/components/theme-toggle";
import { EPICS } from "@/lib/epics";
import { cn } from "@/lib/utils";

const NAV = [
  // Hidden on a phone: the wordmark drops out at that width and the logo
  // beside it is already this link, so the nav can spend its width on the
  // epics instead of on a second way home.
  { to: "/", label: "Home", end: true, className: "hidden sm:block" },
  ...EPICS.map(({ path, label }) => ({ to: path, label, end: false, className: "" })),
];

export function SiteHeader() {
  return (
    <header className="sticky top-0 z-40 border-b bg-background/80 backdrop-blur-sm">
      <div className="mx-auto flex h-14 max-w-5xl items-center gap-3 px-4 sm:gap-6">
        <NavLink to="/" className="flex shrink-0 items-center gap-2 font-semibold tracking-tight">
          <img src="/icon.png" alt="" className="size-6 rounded-md" />
          {/* The wordmark is the first thing to go on a phone: the icon still
              says where "home" is, and the nav needs the width more. */}
          <span className="hidden sm:inline">Endfar</span>
        </NavLink>

        {/* The nav is the only part allowed to overflow. It scrolls inside
            itself so the account and theme controls stay on screen at any
            width, instead of being pushed off the right edge. */}
        <nav
          className={cn(
            "flex min-w-0 flex-1 items-center gap-1 overflow-x-auto text-sm",
            "[scrollbar-width:none] [&::-webkit-scrollbar]:hidden",
          )}
        >
          {NAV.map(({ to, label, end, className }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                cn(
                  "shrink-0 rounded-md px-2 py-1.5 whitespace-nowrap transition-colors sm:px-3",
                  "hover:text-foreground",
                  isActive ? "bg-accent text-foreground" : "text-muted-foreground",
                  className,
                )
              }
            >
              {label}
            </NavLink>
          ))}
        </nav>

        <div className="flex shrink-0 items-center gap-1">
          <AuthMenu />
          <ThemeToggle />
        </div>
      </div>
    </header>
  );
}
